<div class="image-container">
  <div class="skeleton-loader" *ngIf="isLoading"></div>

  <img
    [src]="finalImageSrc"
    [alt]="alt"
    [class.image-loaded]="!isLoading"
    (load)="onImageLoad()"
    (error)="onImageError()"
  />
</div>
